import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-c4g-auth',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './c4g-auth.component.html',
  styleUrl: './c4g-auth.component.css',
})
export class C4gAuthComponent {}
